import * as React from 'react';
import { List , ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import {db} from '../utils/firebase.js';
import { doc, deleteDoc } from "firebase/firestore";
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Item from '@mui/material/ListItem';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Campo from './Campo';
import CampoIcon from './CampoIcon';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import Cell from './Cell';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import ReactDOM from 'react-dom'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const marks = [

    {
      value: 30,
      label: '30 min',
    },
    {
      value: 60,
      label: '1 ora',
    },
    {
      value: 90,
      label: '1 ora e mezza',
    },
  ];

  function valuetext(value) {
    return `${value}°C`;
  }
  
  function valueLabelFormat(value) {
    return marks.findIndex((mark) => mark.value === value) + 1;
  }
  
const Col=({arr, user})=>{

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);



  
  let hours = [];

  let startHour = 8;
  let startMinute = 0;

  const handleSelected = event => {
    // 👇️ toggle class on click
    event.currentTarget.classList.toggle('selected');
    let selected = document.getElementsByClassName('selected')
    
    let fab = document.getElementsByClassName('fab-prenota');

    if(selected.length > 0){
      fab[0].classList.add('shown');
    }
      else{
        fab[0].classList.remove('shown');
      }

  };

  const handleSelectedToRemove = event => {
    // 👇️ toggle class on click
    event.currentTarget.classList.toggle('selectedToRemove');
    let selected = document.getElementsByClassName('selectedToRemove')
    
    let fab = document.getElementsByClassName('fab-prenota-remove');

    if(selected.length > 0){
      fab[0].classList.add('shown');
    }
      else{
        fab[0].classList.remove('shown');
      }

  };

  // for (let i = 8; i <= 23; i++) {

    if(arr.size == 1){
      for (let i = 0; i < 16; i++) {

    
        var itemHour = {};
        itemHour['hour'] = startHour + ':' +startMinute;
        itemHour['size'] = arr.size;
        itemHour['prenotazioni'] = [];
        
        hours[startHour + ':' +startMinute] = itemHour;
    
        // if(i%2 == 0){
          startHour ++;
        // }
      }
    }

    if(arr.size == 2){
      for (let i = 0; i < 32; i++) {

    
        var itemHour = {};
        itemHour['hour'] = startHour + ':' +startMinute;
        itemHour['size'] = arr.size;
        itemHour['prenotazioni'] = [];
        
        hours[startHour + ':' +startMinute] = itemHour;
    
    
        if(i%2 == 0){
          // startHour ++;
          startMinute = 30;
        }else{
          startHour ++;

          startMinute = 0;
        }
      }
    }


  for(let i = 0; i < arr.prenotazione.length; i++){
    let _date = new Date(arr.prenotazione[i]['item']['start_datetime'].toDate());
    let _hour = _date.getHours();
    let _minutes = _date.getMinutes();

    hours[_hour+':'+_minutes]['prenotazioni'].push(arr.prenotazione[i]);
  }

  let _hours = [];

  Object.values(hours).forEach((element) => {
    _hours.push(element);
  });


  let cells = [];
  let prevName = '';
  let tempCells = [];
  let timeRange = [];

  let campo = '';
  let startDatetime = '';

  for(let i = 0; i < _hours.length; i++){
    let full = 'prenotazione-box-wrapper';
    let inside = 'prenotazione-box center';
    let cell = 'cell center';

    if(arr.size == 1){
      full = 'prenotazione-box-wrapper full';
      cell = 'cell center full';
    }

    campo = arr.key;
    startDatetime = new Date(arr.day);
    let _time = _hours[i].hour.split(':');
    startDatetime.setHours(_time[0], _time[1]);

    if(_hours[i].prenotazioni.length > 0){

      let prenotazioneId = _hours[i].prenotazioni[0]['id'];

      let currentName = _hours[i].prenotazioni[0]['item'].name.toUpperCase();
      
      let nextName = '';
      if(_hours[i+1] != undefined && _hours[i+1].prenotazioni[0] != undefined){
        nextName = _hours[i+1].prenotazioni[0]['item'].name.toUpperCase()
      }
      
      inside = 'prenotazione-box center reserved';

      if(currentName != prevName){
        inside = inside + ' start';
        tempCells = [];
        timeRange[0] = _hours[i].hour.replace(':0', ':00');
      }

      if(currentName != nextName){
        inside = inside + ' end';

        if(i+1 < _hours.length){
          timeRange[1] = _hours[i+1].hour.replace(':0', ':00');
        }else{
          timeRange[1] = '24:00';
        }
        
        console.log(timeRange);
        cells.push(<div className='reserved-cell-wrapper'>{tempCells}<div className="name">{user ? currentName : 'PRENOTATO'} <span class="hour-cell-reserved">{timeRange[0]} - {timeRange[1]}</span></div> </div>)
      }

      prevName = currentName;

      tempCells.push (
        <div className={cell}>
            <div className={full}>
            
              <div className={user ? inside : inside + " disabled"} onClick={user ? handleSelectedToRemove : null} data-prenotazione={prenotazioneId}>
                {/* {currentName} */}
              </div>
              
              
          </div>
        </div> 
      );
    
    }else{
      prevName = '';

      cells.push( <div className={cell}><div className={full}>
        {/* <div  onClick={handleOpen} className={inside}> */}
        <div  onClick={user ? handleSelected : null} className={user ? inside : inside + " disabled"} data-campo={campo} data-day={startDatetime}>
        
        </div>
      </div></div>);
    } 

  }

    const headerCellClass = 'header-cell center '+arr.sport;

    let icon = <SportsTennisIcon  color="white" sx={{ display: { xs: 'inline-block', sm: 'none' }, fontSize: 20 }}/>;

    if(arr.sport == 'calcetto'){
      icon = <SportsSoccerIcon  color="white" sx={{ display: { xs: 'inline-block', sm: 'none' }, fontSize: 20 }}/>
    }

    return (
      <Grid item xs={3} sm={3}>
        
        <Stack spacing={0} className="center campo-col">

          <Box className="header-cell-sticky-wrapper">
            <Box className={headerCellClass}>
              <Box sx={{display: 'flex', justifyContent: 'center'}}>
                <span className="campoNumber">{arr.number}</span>
                {icon}
              </Box>

              {/* <Typography gutterBottom variant="body1" component="div" className="campo-label"> */}
                <Box className="campo-label" sx={{ display: { xs: 'none', sm: 'block' } }}>
                {arr.label}
                </Box>
              </Box>
            </Box>
          {/* </Typography> */}

          {/* {_hours.map(item=> <Cell key={item.hour} arr={item}/>)} */}
          {/* <div className="cell center"> */}
            {cells}
            {/* <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              ><Box sx={style}>
                <Grid item xs>
                <Slider
  aria-label="Restricted values"
  defaultValue={30}
  valueLabelFormat={valueLabelFormat}
  getAriaValueText={valuetext}
  step={null}
  valueLabelDisplay="auto"
  marks={marks}
/>
          <TextField id="outlined-basic" label="Nome" variant="outlined" size="small" />
        </Grid>
        <Grid item>
          <Button variant="outlined" color="success">Prenota</Button>
        </Grid>
                </Box></Modal> */}
          {/* </div> */}



        </Stack>

      </Grid> 
        
    )
};

export default Col;